import { registerApp } from '@okapi/core';
import log from 'loglevel';
import { preloadedState, router, store } from 'store';
import { initI18n, getDomain } from 'utils';
import { createEntry } from '../common';

log.setDefaultLevel(preloadedState.env.LOG_LEVEL || ('warn' as log.LogLevelDesc));

if (preloadedState.isBot === false) {
  const domain = getDomain(preloadedState.host);
  initI18n(router.getPath(), domain);

  registerApp(__NAME__, () => createEntry({ store, router }));
}
